import { configure } from 'vee-validate'
import { localize } from '@vee-validate/i18n'
import en from '@vee-validate/i18n/dist/locale/en.json'
import fr from '@vee-validate/i18n/dist/locale/fr.json'
import i18n from '../i18n'

/* The `validation.*` block in each locale file overrides the packaged defaults,
   so wording can be tweaked per locale without forking the whole catalogue.
   Filtered to strings so a nested object can't be handed to localize. */
const customMessages = locale => {
  const validation = i18n.global.getLocaleMessage(locale).validation || {}

  return Object.fromEntries(Object.entries(validation).filter(([, message]) => typeof message === 'string'))
}

/* The single vee-validate configuration point. Locale is driven from App.vue,
   which mirrors the app's i18n locale onto vee-validate via setLocale. */
configure({
  generateMessage: localize({
    en: { messages: { ...en.messages, ...customMessages('en') } },
    fr: { messages: { ...fr.messages, ...customMessages('fr') } }
  }),
  // Validate on blur only, matching the behaviour the v2 components relied on
  validateOnInput: false,
  validateOnChange: false,
  validateOnBlur: true
})
